import React, { FC } from 'react';
import Popup from 'reactjs-popup';
import type { Role } from '../types/UserTable.types';

const parseRoles = (roles: any): number[] => {
  if (!roles) return [];
  if (Array.isArray(roles)) return roles as number[];
  if (typeof roles === 'string') {
    try {
      const parsed = JSON.parse(roles);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {
      // fallthrough
    }
  }
  return [];
};

const UserRolesCell: FC<{ roles: any; allRoles?: Role[] }> = ({ roles, allRoles }) => {
  const parsed = parseRoles(roles);
  const defaultRoleName = allRoles?.find((r) => String(r.role_Id) === String(-2))?.role_name || 'Default Role';

  if (!parsed || parsed.length === 0) return <p className="text-wrap text-white fs-6">{defaultRoleName}</p>;

  const visibleRoles = parsed.filter((r) => r !== -2);

  if (visibleRoles.length > 1) {
    return (
      <Popup
        trigger={<p className="text-wrap text-white fs-6">Multiple Roles</p>}
        position="top center"
        on="hover"
        closeOnDocumentClick
      >
        <div className="bg-primary border border-secondary rounded">
          {visibleRoles.map((role, index) => (
            <p key={index} className="p-1 mb-0">
              {allRoles?.find((r) => String(r.role_Id) === String(role))?.role_name || 'missing?'}
            </p>
          ))}
        </div>
      </Popup>
    );
  }

  // If there are no visible roles (e.g. parsed contains only sentinel like -2),
  // fall back to the default role name.
  if (visibleRoles.length === 0) {
    return <p className="text-wrap text-white fs-6">{defaultRoleName}</p>;
  }

  const first = visibleRoles[0];
  const resolved = allRoles?.find((r) => String(r.role_Id) === String(first))?.role_name;
  return <p className="text-wrap text-white fs-6">{resolved ?? 'missing?'}</p>;
};

export default UserRolesCell;
